/**
 * Created by cg51 on 13/01/2017.
 */

'use strict';

function StandardTables() {

    var wrapper = '<div class="scrollStyle"/>';

    /********************************/
    // Apply wrapper
    /********************************/
    this.applyWrapper = function () {
        $('table:not(.dpl-datatable, .tablesaw)').each(function(){
            $(this).wrap(wrapper);
        });
    };
}
